export const ARMOIRE_RELEASE_DATES = {
  somethingSpooky: { year: 2023, month: 10 },
  cookingImplementsTwo: { year: 2023, month: 11 },
  greenTrapper: { year: 2023, month: 12 },
  schoolUniform: { year: 2024, month: 1 },
  whiteLoungeWear: { year: 2024, month: 2 },
  hatterSet: { year: 2024, month: 3 },
  optimistSet: { year: 2024, month: 4 },
  pottersSet: { year: 2024, month: 5 },
  beachsideSet: { year: 2024, month: 6 },
  corsairSet: { year: 2024, month: 7 },
  dragonKnightSet: { year: 2024, month: 8 },
  funnyFoolSet: { year: 2024, month: 9 },
  frightNightSet: { year: 2024, month: 10 },
  stormKnightSet: { year: 2024, month: 11 },
  festiveHelperSet: { year: 2024, month: 12 },
  snowyTrapperSet: { year: 2025, month: 1 },
  fancyFloralSet: { year: 2025, month: 2 },
  springPetalSet: { year: 2025, month: 3 },
  sillyTuxedoSet: { year: 2025, month: 4 },
  sillierTuxedoSet: { year: 2025, month: 4 },
  gildedKnightSet: { year: 2025, month: 5 },
};

export const EGGS_RELEASE_DATES = {
  Giraffe: { year: 2024, month: 6, day: 1 },
  Chameleon: { year: 2024, month: 7, day: 14 },
  Crab: { year: 2024, month: 8, day: 14 },
  Raccoon: { year: 2024, month: 9, day: 14 },
  Dog: { year: 2024, month: 10, day: 14 },
  Cat: { year: 2025, month: 2, day: 14 },
  Otter: { year: 2025, month: 3, day: 14 },
  Alpaca: { year: 2025, month: 4, day: 14 },
  Platypus: { year: 2025, month: 5, day: 14 },
};

export const HATCHING_POTIONS_RELEASE_DATES = {
  Koi: { year: 2024, month: 6, day: 1 },
  Gingerbread: { year: 2024, month: 12, day: 21 },
  Jade: { year: 2025, month: 3, day: 14 },
  Cryptid: { year: 2025, month: 4, day: 3 },
  Balloon: { year: 2025, month: 4, day: 21 },
  Opal: { year: 2025, month: 5, day: 14 },
};
